import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  card: {
    padding: theme.spacing(3),
  },
  description: {
    marginBottom: theme.spacing(2),
  },
  savingSpinner: {
    marginTop: theme.spacing(2),
  },
}));
